module.exports = __webpack_public_path__ + "static/media/HAUX_TRAINING_GUIAS_FORCA.095618a9.pdf";